import { Link, useLocation } from "react-router";
import { ChevronRight, Home } from "lucide-react";
import { getBreadcrumbs } from "./SchemaMarkup";

export function Breadcrumb() {
  const { pathname } = useLocation();

  return null;
  if (pathname === "/") return null;

  const crumbs = getBreadcrumbs(pathname);

  return (
    <nav
      aria-label="Breadcrumb"
      className="mx-auto max-w-7xl px-6 lg:px-8 py-3"
    >
      <ol className="flex flex-wrap items-center gap-1 text-sm text-muted-foreground">
        {crumbs.map((crumb, i) => {
          const isLast = i === crumbs.length - 1;
          return (
            <li key={crumb.path} className="flex items-center gap-1">
              {i === 0 ? (
                <Link
                  to="/"
                  className="flex items-center gap-1 hover:text-[#131312] transition-colors"
                  aria-label="Home"
                >
                  <Home className="size-3.5" />
                </Link>
              ) : isLast ? (
                <span className="text-[#131312] font-medium" aria-current="page">
                  {crumb.name}
                </span>
              ) : (
                <Link
                  to={crumb.path}
                  className="hover:text-[#131312] transition-colors"
                >
                  {crumb.name}
                </Link>
              )}
              {!isLast && <ChevronRight className="size-3.5 flex-shrink-0 opacity-50" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
